import React from 'react'
// import '../css/style.css'
import CircularProgress from '@mui/material/CircularProgress'

function Loading() {
  return (
    <div className="loading">
      {/* <img src={logo} width={100} height={100} /> */}
      <CircularProgress />
    </div>
  )
}

export default Loading
